import { createSlice } from '@reduxjs/toolkit';

const DashboardSlice = createSlice({
  name: 'DashboardSlice',
  initialState: {
    isLoading: false,
    dashboardData: [],
    revenueGraphData: [],
    revenueOverviewData: [],
    errorOverviewData: [],
    merchantNameList: [],
    recurringUsers: [],
    sellerCommissionData: [],
    countryRevenueData: [],
    revenuePerStationData: null,
    fieldValidationError: null,
    isError: null,
    isRevenueOverviewLoading: false,
    isRecurringLoading: false,
    isErrorLoading: false,
    isSellerCommissionLoading: false,
    isCountryRevenueLoading: false,
    // RAT-1926: deliberately kept out of the dashboard-wide isAnyApiLoading so
    // switching the chart's scope/breakdown never disables the page filters.
    isRevenuePerStationLoading: false,
  },
  reducers: {
    /////// Login start //////
    requestDashboardData: (state) => {
      return { ...state, isLoading: true };
    },
    responseDashboardData: (state, action) => {
      return {
        ...state,
        isLoading: false,
        dashboardData: action?.payload?.data,
        fieldValidationError: null,
      };
    },
    failureDashboardData: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isError: action?.payload,
        fieldValidationError: action?.payload,
      };
    },

    requestRevenueGraphData: (state) => {
      return { ...state, isLoading: true };
    },
    responseRevenueGraphData: (state, action) => {
      return {
        ...state,
        isLoading: false,
        revenueGraphData: action?.payload?.data,
        fieldValidationError: null,
      };
    },
    failureRevenueGraphData: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isError: action?.payload,
        fieldValidationError: action?.payload,
      };
    },

    requestRevenueOverviewData: (state) => {
      return { ...state, isRevenueOverviewLoading: true };
    },
    responseRevenueOverviewData: (state, action) => {
      return {
        ...state,
        isRevenueOverviewLoading: false,
        revenueOverviewData: action?.payload?.data,
        fieldValidationError: null,
      };
    },
    failureRevenueOverviewhData: (state, action) => {
      return {
        ...state,
        isRevenueOverviewLoading: false,
        isError: action?.payload,
        fieldValidationError: action?.payload,
      };
    },

    ///  ERROR OVERVIEW ///
    requestErrorOverviewData: (state) => {
      return { ...state, isErrorLoading: true };
    },
    responseErrorOverviewData: (state, action) => {
      return {
        ...state,
        isErrorLoading: false,
        errorOverviewData: action?.payload?.data,
        fieldValidationError: null,
      };
    },
    failureErrorOverviewData: (state, action) => {
      return {
        ...state,
        isErrorLoading: false,
        isError: action?.payload,
        fieldValidationError: action?.payload,
      };
    },

    ///  RECURRING USERS ///
    requestRecurringUsers: (state) => {
      return { ...state, isRecurringLoading: true };
    },
    responseRecurringUsers: (state, action) => {
      return {
        ...state,
        isRecurringLoading: false,
        recurringUsers: action?.payload?.data,
        fieldValidationError: null,
      };
    },
    failureRecurringUsers: (state, action) => {
      return {
        ...state,
        isRecurringLoading: false,
        isError: action?.payload,
        fieldValidationError: action?.payload,
      };
    },

    ///  REVENUE PER STATION (RAT-1926) ///
    requestRevenuePerStation: (state) => {
      return { ...state, isRevenuePerStationLoading: true };
    },
    responseRevenuePerStation: (state, action) => {
      return {
        ...state,
        isRevenuePerStationLoading: false,
        revenuePerStationData: action?.payload?.data,
        fieldValidationError: null,
      };
    },
    failureRevenuePerStation: (state, action) => {
      return {
        ...state,
        isRevenuePerStationLoading: false,
        isError: action?.payload,
        fieldValidationError: action?.payload,
      };
    },

    requestMerchantNameList: (state) => {
      return { ...state, isLoading: true };
    },
    responseMerchantNameList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        merchantNameList: action?.payload?.data,
        fieldValidationError: null,
      };
    },
    failureMerchantNameList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isError: action?.payload,
        fieldValidationError: action?.payload,
      };
    },

    ///  SELLER COMMISSION ///
    requestSellerCommission: (state) => {
      return { ...state, isSellerCommissionLoading: true };
    },
    responseSellerCommission: (state, action) => {
      return {
        ...state,
        isSellerCommissionLoading: false,
        sellerCommissionData: action?.payload?.data,
        fieldValidationError: null,
      };
    },
    failureSellerCommission: (state, action) => {
      return {
        ...state,
        isSellerCommissionLoading: false,
        isError: action?.payload,
        fieldValidationError: action?.payload,
      };
    },

    ///  COUNTRY REVENUE ///
    requestCountryRevenue: (state) => {
      return { ...state, isCountryRevenueLoading: true };
    },
    responseCountryRevenue: (state, action) => {
      return {
        ...state,
        isCountryRevenueLoading: false,
        countryRevenueData: action?.payload?.data,
        fieldValidationError: null,
      };
    },
    failureCountryRevenue: (state, action) => {
      return {
        ...state,
        isCountryRevenueLoading: false,
        isError: action?.payload,
        fieldValidationError: action?.payload,
      };
    },
  },
});

export const {
  failureDashboardData,
  requestDashboardData,
  responseDashboardData,
  requestRevenueGraphData,
  responseRevenueGraphData,
  failureRevenueGraphData,
  requestRevenueOverviewData,
  responseRevenueOverviewData,
  failureRevenueOverviewhData,
  requestMerchantNameList,
  responseMerchantNameList,
  failureMerchantNameList,
  requestErrorOverviewData,
  responseErrorOverviewData,
  failureErrorOverviewData,
  requestRecurringUsers,
  responseRecurringUsers,
  failureRecurringUsers,
  requestSellerCommission,
  responseSellerCommission,
  failureSellerCommission,
  requestCountryRevenue,
  responseCountryRevenue,
  failureCountryRevenue,
  requestRevenuePerStation,
  responseRevenuePerStation,
  failureRevenuePerStation,
} = DashboardSlice.actions;
export default DashboardSlice.reducer;
